import $ from 'jquery';
import ModalVideoWithParameters from '../../components/modal-video-with-parameters';
import RevealWhenVisible from '../../components/reveal-when-visible';
$(() => {
    ModalVideoWithParameters.init();
    RevealWhenVisible.init();
});
